import { createBrowserHistory } from "history";
/*
* export sample history
*/
export const history = createBrowserHistory();
